'use strict';

const { CLASSES } = require('../utils/globals');
const SELECTORS = {
    body: 'body',
    articleGrid: '.js-article-grid',
    loadMoreBtn: '.js-blog-load-more-btn',
    loadMoreBtnContainer: '.js-blog-load-more-btn-container',
    lazyLoadIntersect: '.lazy-load-intersect',
}

/**
 * Loads content into the article grid based on load more click
 *
 * @param {Object} $element - jQuery element being clicked
 * @param {Object} $target - jQuery element to load results into
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');

    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $(SELECTORS.articleGrid).removeClass(CLASSES.active);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Initialize inifinite scroll.
 * @param {*} target
 */
function initObserver(target) {
    let $target = document.querySelector(SELECTORS.lazyLoadIntersect);

    if (target) {
        $target = target;
    }

    if ($target) {
        let observer = new IntersectionObserver(handleIntersect, {
            threshold: 0.5
        });
        observer.observe($target);
    }
}

/**
 * Handles the intersect event.
 * @param {*} entries
 * @param {*} observer
 */
function handleIntersect(entries, observer) {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            let $target = document.querySelector(SELECTORS.lazyLoadIntersect);
            observer.unobserve($target);

            setTimeout(function () {
                const $loadMoreButton = $(SELECTORS.loadMoreBtn);
                if ($loadMoreButton.length) {
                    $(this).trigger('blog:showMore');
                    loadMoreBlogPosts($loadMoreButton.data('url'));
                }
            }, SitePreferences.PDP_LAZY_LOAD_SPEED);
        }
    });
}

/**
 * Loads more blog posts on scroll
 * @return {undefined}
 */
function loadMoreBlogPosts(showMoreUrl) {
    const data = { selectedUrl: showMoreUrl };
    $(SELECTORS.lazyLoadIntersect).removeClass('lazy-load-intersect');

    $.ajax({
        url: showMoreUrl,
        data,
        dataType: 'html',
        method: 'GET',
        success:  function (response) {
            var $response = $(response);
            $(SELECTORS.loadMoreBtnContainer).replaceWith($response);
            initObserver();
        }
    });
}

/**
 * Init blog js.
 */
function init() {
    initObserver();

    $(SELECTORS.body).on('click', SELECTORS.loadMoreBtn, function () {
        getContent($(this), $(SELECTORS.articleGrid));
        $(SELECTORS.articleGrid).addClass(CLASSES.active);
        $(SELECTORS.loadMoreBtnContainer).remove();
    });
}

module.exports = init();